export default __webpack_public_path__ + "static/media/bag_original.7fdd71ff.jpg";